import React from "react";
import "./PlayButton.scss";

const PlayButton = ({ size = "large", className = "" }) => {
  return (
    <div className={`bs-play-button bs-play-button--${size} ${className}`}>
      <div className="bs-play-button__circle">
        <div className="bs-play-button__triangle"></div>
      </div>
    </div>
  );
};

export default PlayButton;
